import React from "react";
import { getOrg, getMeetingBookingUrl } from "../../../utils/site";
import { organizationData } from "./data";
import { i18n } from "next-i18next";

const getOrganizationStructuredData = () => {
  const org = getOrg();
  const locale = i18n?.language;

  // Build the locale key based on org and language
  let localeKey: keyof typeof organizationData | null = null;

  switch (org) {
    case "swe":
      localeKey = locale === "sv" ? "sv-SE" : "en-SE";
      break;
    case "ger":
      localeKey = locale === "de" ? "de-DE" : "en-DE";
      break;
    case "fra":
      localeKey = locale === "fr" ? "fr-FR" : "en-FR";
      break;
    // The UK ships a single locale, so there is no native/English split here.
    case "gbr":
      localeKey = "en-GB";
      break;
    default:
      return null;
  }

  const baseData = organizationData[localeKey];
  const bookingUrl = getMeetingBookingUrl();

  // If no booking URL, return the data as-is
  if (!bookingUrl) {
    return baseData;
  }

  // Deep clone and add ScheduleAction to each offer's potentialAction array
  const enhancedData = JSON.parse(JSON.stringify(baseData));
  
  if (enhancedData.hasOfferCatalog?.itemListElement) {
    enhancedData.hasOfferCatalog.itemListElement.forEach((catalog: any) => {
      if (catalog.itemListElement) {
        catalog.itemListElement.forEach((offer: any) => {
          if (offer.potentialAction && Array.isArray(offer.potentialAction)) {
            offer.potentialAction.push({
              "@type": "ScheduleAction",
              target: bookingUrl,
            });
          }
        });
      }
    });
  }

  return enhancedData;
};

export const OrganizationStructuredData = () => {
  const data = getOrganizationStructuredData();

  if (!data) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};
